import api from '@/api';
import { DateTime } from 'luxon';

export default {
    namespaced: true,
    state: {
        mesas: [],
        currentElection: null,
    },
    getters: {
        mesas: state => state.mesas,
        mesa: state =>
            function(mesaId) {
                return state.mesas.find(mesa => mesa.id === mesaId);
            },
        currentElection: state => state.currentElection,
    },
    mutations: {
        setMesas(state, mesas) {
            state.mesas = mesas;
        },
        setMesa(state, mesa) {
            state.mesa = mesa;
        },
        setCurrentElection(state, election) {
            state.currentElection = election;
        },
    },
    actions: {
        async fetchMesas({ commit }, { election_id }) {
            commit('setCurrentElection', null);
            commit('setMesas', []);

            const response = await api.get(`/elections/${election_id}/mesas`);

            if (!response.data) {
                return;
            }

            if (response.data.election) {
                commit('setCurrentElection', response.data.election);
            }

            if (Array.isArray(response.data.votingStations)) {
                const mesas = response.data.votingStations.map(mesa => {
                    const { nombre, opened_at, is_open } = mesa;

                    if (!is_open && !opened_at) {
                        mesa.status = 'Mesa sin aperturar';
                    } else if (is_open && opened_at) {
                        mesa.status = 'Mesa aperturada';
                    }
                    if (!is_open && opened_at) {
                        mesa.status = 'Mesa cerrada';
                    }

                    if (opened_at) {
                        mesa.opened_at = DateTime.fromISO(
                            mesa.opened_at
                        ).toLocaleString(DateTime.DATETIME_MED);
                    } else {
                        mesa.opened_at = '-';
                    }

                    if (!nombre) {
                        mesa.nombre = 'No info';
                    }

                    return mesa;
                });
                commit('setMesas', mesas);
            }
        },
        async openStation(_, { election_id, mesa_id }) {
            const response = await api.post(
                `/elections/${election_id}/mesas/${mesa_id}/open`
            );
            return response.data;
        },
    },
};
